import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { EnvironmentStore } from '../components/environment/environment.store';

export const adGuard: CanActivateFn = (route, state) => {
  const store = inject(EnvironmentStore);
  const router = inject(Router);
  console.log(store.environment()?.isAd);
  return store.environment()?.isAd !== true ? true : router.parseUrl('/');
};
